<template>
  <div class="viewer-modal">
    <div class="viewer-modal-header">
      <div class="column">
        <div class="columns is-flex is-align-items-center is-justify-content-center">
          <div class="column is-narrow has-background-black-bis has-text-white viewer-modal-col">
           <i class="icon-modelprojectnavigator"></i>
          </div>
          <div class="column is-9">
            <h3 class="has-text-weight-semibold is-size-6 has-text-dark has-text-left">SELECT PROJECT MODEL</h3>
          </div>
          <div class="column is-narrow">
            <button class="button px-0 has-text-black-bis pointer"><i class="icon-windowhandle"></i></button>
          </div>
        </div>             
      </div>
    </div>
    <div class="viewer-modal-body">
      <ul>
        <li v-for="model in models" :key="model.id" class="pointer is-relative">
          <div class="is-align-items-center is-flex">
            <div class="model-col">
              <span class="is-pulled-left" v-if="isFooterVisible">
                  <input type="radio" :id="model.id" :value="model" v-model="selectedModel" 
                :checked="selectedModel.id === model.id"  class="pl-0"/>
                  <label class="pl-0 viewer-radio-btn" :for="model.id"></label>
              </span>
              <span class="is-pulled-left model-arrow-btn">
                <i class="pointer" @click="model.isExpanded = !model.isExpanded"
                  :class="[model.isExpanded ? 'icon-disclosearrow': 'icon-disclosearrowright', isFooterVisible ? 'ml-5' : '']"> </i>
              </span >
               <span class="is-pulled-left text-overflow-bimplus is-size-3" v-tooltip="model.name">
                <h6>{{ model.name }}</h6>
              </span>
              <i class="icon-show pointer is-pulled-right" @click="toggleModelVisibilty(model)"
                :class="model.eyeSelected ? 'has-text-black' : 'has-text-grey-dark'"></i>
              <ul v-if="model.isExpanded">
                <li v-for="discipline of model._layers" :key="discipline.id">
                  <div class="is-flex is-align-items-center is-justify-content-space-between">
                    <span class="is-pulled-left">
                      {{ discipline.name }}
                    </span>
                    <span class="is-pulled-right">
                      <i class="icon-show" @click="toggleLayerVisibility(discipline, model)"
                      :class="discipline.eyeSelected || model.eyeSelected ? 'has-text-black' : 'has-text-grey-dark'"></i>
                    </span>
                  </div>
                </li>
              </ul>              
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div v-if="isFooterVisible" class="viewer-modal-footer">
      <button class="button is-outlined has-text-weight-bold is-size-3 mr-2"
        @click="closeViewer">
        Cancel
        </button>
        <button class="button has-background-black-bis has-text-weight-bold is-size-3 has-text-white"
          @click="openView()" :disabled="$_.isEmpty(selectedModel)">
        Continue
        </button>
    </div>
  </div>
  <o-loading :full-page="true" :active="isLoading" :can-cancel="false"></o-loading>
</template>

<script>
import {reactive, toRefs, onMounted} from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useStore } from 'vuex';
import bimplusViewer from '../../views/bimplus/bimplusViewer';

export default {
  name: 'ProjectModelsNavigator',
  props: {
    projectId: {
      type: String,
      default: '',
    },
    models: {
      type: Array,
      required: true
    },
    isFooterVisible: {
      type: Boolean,
      default: true
    },
    bimplusProjectId: {
      type: String,
      default: '',
    },
    setModelVisible: {
      type: Boolean,
      default: false
    },
    guidsList: {
      type: Array,
      default: () => []
    },
    addObjectsBySelection: {
      type: Boolean,
      default: false
    }
  },

  setup(props) {
    const router = useRouter();
    const route = useRoute();
    const store = useStore();
    const data = reactive ({
      isModelLayerVisible: true,
      isfromModelViewer: false,
      selectedModel: {},
      selectedEye: {},
      isLoading: false,
    });
    const toggleModelVisibilty = async (model) => {
      try {
        data.isLoading = true;
        model.eyeSelected = !model.eyeSelected;
        // if (!model.eyeSelected) {
          const layerKeys = Object.keys(model._layers)
          _.forEach(layerKeys, (k) => {
            model._layers[k].eyeSelected = model.eyeSelected;
          });
        // }
        if(model.eyeSelected) {
          await bimplusViewer.showModel(props.bimplusProjectId, model);
        } else {
          await model.setVisible(false);
          bimplusViewer.redrawModel();
        }
      } catch (e) {
        console.log('Error: ', e);
      } finally {
        data.isLoading = false
      }
    };

    const toggleLayerVisibility = async (layer, model) => {
      try {
        data.isLoading = true;
        layer.eyeSelected = !layer.eyeSelected
        const layerKeys = Object.keys(model._layers)
        const isAllLayerSelected = _.every(layerKeys, (k) => {
          return model._layers[k].eyeSelected;
        });
        if (isAllLayerSelected) model.eyeSelected = true;
        else {
          model.eyeSelected = false;
        }
        await layer.setVisible(layer.eyeSelected);
        bimplusViewer.redrawModel();
      } catch (e) {
        console.log('Error: ', e);
      } finally {
        data.isLoading = false;
      }
      
    };

    const openView = () => {
      const routeFrom = _.get(route.query, 'from', '');
      console.log('--------->routeFrom', routeFrom);
      
      if(routeFrom === 'createOrder') {
        router.push({
          name: 'bim-create',
          params: {
            projectId: props.projectId,
          },
          query: {
            divisionTopologyId: data.selectedModel.divisionTopologyId,
            modelId: data.selectedModel.id,
          },
        });
      }
      if(routeFrom === 'addModelObjects') {
        router.push({
          name: 'bimplus-additems',
          params: {
            projectId: props.projectId,
            cardId: _.get(route.query, 'cardId', ''),
          },
          query: {
            topologyId: data.selectedModel.divisionTopologyId // selectedModel.topologyId
          }
        });
      }
      
    };

    const hextoRgb = (hex) => {
      hex = hex.replace(/^#/, '');
      
      let bigint = parseInt(hex, 16);
      let r = (bigint >> 16) & 255;
      let g = (bigint >> 8) & 255;
      let b = bigint & 255;

      return `rgb(${r}, ${g}, ${b})`;
    };

    const closeViewer = () => {
      router.push({path: '/manager/detailing'});
    };

    onMounted( async () => {
      try {
        data.isLoading = true;
        data.isfromModelViewer = !props.isFooterVisible;

        if(!props.addObjectsBySelection) {
          console.log('--------->props.addObjectsBySelection', props.addObjectsBySelection);
          for (let i=0; i<props.models.length; i++) {
            await bimplusViewer.showModel(props.bimplusProjectId, props.models[i]);
            props.models[i].setVisible(props.setModelVisible);
            if(props.setModelVisible) {
              const guids = props.guidsList.map(x => x.guid.split('*')[1] || x.guid);
              bimplusViewer.isolateObjects(guids);

              const groupedByColor = _.groupBy(props.guidsList, "color");

              const colorGuidMap = {};
              for(const[hexaColorCode, guids] of Object.entries(groupedByColor)) {
                const rgbColor = hextoRgb(hexaColorCode);
                colorGuidMap[rgbColor] = guids.map(x => x.guid.split('*')[1] || x.guid);
              }

              for(const[rgColor, guids] of Object.entries(colorGuidMap)) {
                bimplusViewer.setMfactColors(guids, rgColor);
              }
            }
          }
        }
        
      } catch (e) {
        console.log('Error: ', e);
      } finally {
        data.isLoading = false;
      }
    });

    return {
      ...toRefs(data),
      toggleModelVisibilty,
      toggleLayerVisibility,
      openView,
      closeViewer
    }
  },
  
};
</script>